import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const hubDeliveryService = {};

// List HubDelivery
hubDeliveryService.listHubDelivery = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/hub-deliveries`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create HubDelivery
hubDeliveryService.createHubDelivery = data => {
  return fetchV2({
    url: `${env.API_MSP}/hub-deliveries`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail HubDelivery
hubDeliveryService.detailHubDelivery = ({
  hubDeliveryId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-deliveries/${hubDeliveryId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update HubDelivery
hubDeliveryService.updateHubDelivery = ({
  hubDeliveryId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-deliveries/${hubDeliveryId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

hubDeliveryService.listHubContact = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/hub-contacts`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

export default hubDeliveryService;
